import { Route } from "@angular/router";
import { MeusEmprestimosPage } from "./meus-emprestimos.page";

export const MeusEmprestimosRouter: Route[] = [
  { path: 'meus-emprestimos', component: MeusEmprestimosPage }
];
